import useTranslatewrapper from "../../../components/useTranslateWrapper";

export default function useLabDetailsSchemaFn() {
  const { translate } = useTranslatewrapper();

  return {
    type: "object",
    properties: {
      BatchNo: {
        type: "string",
        title: translate('shipmentNo'),
      },
      SampleSentDate: {
        type: "string",
        format: "date",
        title: translate('sampleSentDate'),
      },
    },
    required: ["SampleSentDate", "BatchNo"],
  };
}
